import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-161">
      <div className="max-w-4xl mx-auto text-center" data-id="element-162">
        {/* Logo */}
        <div className="text-[#F97316] text-3xl font-black tracking-widest mb-8" data-id="element-163">
          🏀 PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-164">
          El próximo lunes podés volver a improvisar el entrenamiento.
        </h2>
        <p className="text-[#F97316] text-2xl sm:text-3xl font-black mb-10" data-id="element-165">
          O podés entrar al gimnasio con todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#1a0f00] border border-[#F97316]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-166">
          <div className="p-4 bg-[#0d0700] border-b border-[#F97316]/30 text-center font-bold text-white" data-id="element-167">
            ¿Cuánto cuesta NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-[#0d0700] border-b border-[#F97316]/30" data-id="element-168">
            <div className="p-4 font-bold text-gray-400 text-center" data-id="element-169">
              SIN MEGAPACK
            </div>
            <div className="p-4 font-bold text-[#F97316] text-center sm:border-l border-[#F97316]/30" data-id="element-170">
              CON MEGAPACK
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-171">
            <div className="p-4 text-gray-400 text-sm" data-id="element-172">
              100+ horas/año planificando desde cero
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-173">
              10 min/semana. El resto es entrenar.
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-174">
            <div className="p-4 text-gray-400 text-sm" data-id="element-175">
              Drills improvisados → mismo error por meses
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-176">
              101 drills listos → se resuelve en la sesión
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-177">
            <div className="p-4 text-gray-400 text-sm" data-id="element-178">
              Jugadores que abandonan sin saber por qué
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-179">
              Sistema de cohesión → retención visible
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-180">
            <div className="p-4 text-gray-400 text-sm" data-id="element-181">
              Sin progresión clara por categoría
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-182">
              6 tomos con categorías progresivas → mejoran y se quedan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-183">
            <div className="p-4 text-gray-400 text-sm" data-id="element-184">
              Sin Plan B cuando falta el gimnasio
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-185">
              Kit de Adaptación: 12 recetas listas
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-186">
            <div className="p-4 text-gray-400 text-sm" data-id="element-187">
              Categorías mezcladas = caos de entrenamiento
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-188">
              6 adaptaciones listas → todos mejoran juntos
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-189">
            <div className="p-4 text-gray-400 text-sm" data-id="element-190">
              Discusiones con padres sin respuesta correcta
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-191">
              60 mensajes listos → cerrás el tema en 2 mensajes
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-192">
            <div className="p-4 text-gray-400 text-sm" data-id="element-193">
              Sin sistema de medición de progreso
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-194">
              6 métricas simples → mostrás el avance con datos
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-195">
            <div className="p-4 text-gray-400 text-sm" data-id="element-196">
              Sin identidad profesional como entrenador
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-197">
              Sistema visual que justifica cobrar lo que merecés
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-198">
          <p className="text-white font-bold mb-4" data-id="element-199">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-200" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-201">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-202">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-203">
          <div className="bg-[#0a0a0a] border border-[#F97316]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-204">
            <div className="text-2xl mb-2" data-id="element-205">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-206">
              MEGAPACK BÁSQUET LISTO
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-207">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-208">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-209">
                Antes: $34.990 ARS
              </p>
              <p className="text-[#F97316] text-2xl font-black mb-4" data-id="element-210">
                Hoy: $19.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48565380612352:1" className="btn-green-pulse block bg-[#F97316] text-black font-black py-4 rounded-lg hover:bg-[#FB923C] transition-colors text-sm" data-id="element-211">
                → QUIERO MI MEGAPACK BÁSQUET
              </a>
            </div>
          </div>

          <div className="bg-[#0d0700] border-2 border-[#F97316] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(249,115,22,0.2)] flex flex-col" data-id="element-212">
            <div className="text-2xl mb-2" data-id="element-213">🏆</div>
            <h3 className="text-[#F97316] font-black mb-1" data-id="element-214">
              MEGAPACK + KIT TÁCTICO PRO ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-1" data-id="element-215">La más elegida</p>
            <p className="text-gray-400 text-xs mb-4" data-id="element-216">
              6 Tomos + 6 Bonos + Kit Táctico Pro™
              <br data-id="element-217" />
              (pizarras, diagramas, señales visuales y video-scouting)
            </p>
            <div className="mt-auto" data-id="element-218">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-219">
                Antes: $43.990 ARS
              </p>
              <p className="text-[#F97316] text-3xl font-black mb-4" data-id="element-220">
                Hoy: $27.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48565380645120:1" className="btn-green-pulse block bg-[#F97316] text-black font-black py-4 rounded-lg hover:bg-[#FB923C] transition-colors text-sm" data-id="element-221">
                → QUIERO EL MEGAPACK + KIT TÁCTICO PRO
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-222">
          <span data-id="element-223">🔒 Pago 100% seguro</span>
          <span data-id="element-224">⚡ Acceso en 5 minutos</span>
          <span data-id="element-225">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-226">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}